import { useNotificationRoutes } from "./routes";
import { DateTimeViewer, GetDefaultIndex } from "../../components";
import { Descriptions } from "antd";
import { useGetNotificationCommonInfoQuery } from "../../features/identity/notificationsApi";
import { NotificationInfoModel } from "../../entities/notification";

export { useNotificationRoutes };

export default GetDefaultIndex({
  title: "اعلانات",
  query: useGetNotificationCommonInfoQuery,
  generalInfoPresentor: (info: NotificationInfoModel) =>
    info ? (
      <Descriptions size="small" column={{ xxl: 4, xl: 3, lg: 2, md: 2, sm: 1, xs: 1 }}>
        <Descriptions.Item label="تعداد کل" labelStyle={{ color: "gray" }}>
          {info.totalRecords}
        </Descriptions.Item>
        <Descriptions.Item label="تعداد فعال" labelStyle={{ color: "gray" }}>
          {info.activeRecords}
        </Descriptions.Item>
        <Descriptions.Item label="آخرین اضافه" labelStyle={{ color: "gray" }}>
          <DateTimeViewer value={info.lastCreateAt} mode="distance" />
        </Descriptions.Item>
      </Descriptions>
    ) : null,
});
